<template>
  <div class="colors-view">
    <div class="column column-left"></div>
    <div class="column column-center"> 
      <h1 id="title">Colors in Japanese</h1>
      <div id="intro"> So you’ve decided to pick up Japanese? To learn any language is a journey with many peaks and valleys. Japanese is considered one of the hardest languages to learn for English speakers. However, don’t let this discourage you. Some concepts are hard to understand but others are easier. Every journey starts with a 1000 steps so start yours by learning the most fundamental 11 japanese colors! </div>
      <div class="color-container">
        <h3>1. Blue - 青</h3> 
        <span>Blue,  blue I owe you, aoi is it true?</span>
        <!-- <div>Picture</div> -->
        <p class="color-main-text">The Japanese word for blue is ao. The a is pronounced like the ah in father. The o is    pronounced like the phrase “oh” when being told new information. Together they make ao. Here is the Japanese characters that represent that sound 青. 
          We don’t want to scare you off but make sure to memorize these chars as there will be a quiz at the end of class.</p>
      </div>
      <div class="color-container">
        <h3>2. Yellow - 黄</h3> 
        <span>What color is your key? Is it yellow?</span>
        <!-- <div>Picture</div> -->
        <p class="color-main-text">Do you know the key to remembering what yellow is in Japanese? Just remember a yellow key because the Japanese word for yellow is pronounced like the word key. </p>
      </div>
      <div class="color-container">
        <h3>3. Red - 赤</h3> 
        <span>A cobbler is red.</span>
        <!-- <div>Picture</div> -->
        <p class="color-main-text">After learning blue and yellow I'm starting to feel hungry. You know what sounds good right now? A cobbler. A nice raspberry red cobbler. Aka like the first part of “a ka-bler” is the word for red. An interesting fact about this word is that it is used in the word for babies: akachan 赤ちゃん. This is due to the baby's face being red when they are born.</p>
      </div>
      <div class="color-container">
        <h3>4. Black - 黒</h3> 
        <span>The black curow sits on the fence.</span>
        <!-- <div>Picture</div> -->
        <p class="color-main-text">Kuro kind of sounds not cool if you ask me, but that curow does seem cool. This is a pretty easy one, kuro means black. I think that it kind of sounds like “crow”. Anyways make sure to stick this phrase in your brain to learn black.</p>
      </div>
      <div class="color-container">
        <h3>5. White - 白</h3> 
        <span>She row in a white canoe.</span>
        <!-- <div>Picture</div> -->
        <p class="color-main-text">White, the color for purity and cleanliness. This a very useful word to know, gets thrown around alot. Especially when talking about how she row in that white boat. Shiro is the name for white. That is where “she” and “row” come from. Interesting thing about this character is that it comes from the character for day or light. So you can memorize the meaning that way too.</p>
      </div>
      <div class="color-container">
        <h3>6. Pink - ピンク</h3> 
        <span>Pi-n-ku</span>
        <!-- <div>Picture</div> -->
        <p class="color-main-text">PINKU! This will be the easiest color to learn in this list. Japanese has a ton of loan words and pink is one of them. This word is basically pink spelled phonetically using the Japanese alphabet. The only issue is memorizing those three sounds: pi like “P”, the ン is pronounced similar to an n and the last sound is ku like when a bird says “coo”.</p>
      </div>
      <div class="color-container">
        <h3>7. Purple - 紫</h3> 
        <span>Moo raw sucky.</span>
        <!-- <div>Picture</div> -->
        <p class="color-main-text">Purple is the longest word we will be learning in this section. This is kind of gross but imagine a raw steak when it starts to turn, it begins to turn a hint of purple. This explains the remembrance phrase: moo (cow) raw sucky (spoiled). However the pronunciation is slightly different. Sucky is pronounced like the japanese alcohol: saki. Put it together you get murasaki. 
        </p>
      </div>
      <div class="color-container">
        <h3>8. Brown - 茶</h3> 
        <span>That cya tea sure is brown.</span>
        <!-- <div>Picture</div> -->
        <p class="color-main-text">This character is super interesting but is a bit of a misnomer. The way the Japanese describe things that are brown is by comparing them to tea. Also chiya comes from the word chai. Chai in most languages means tea, so this explains why it sounds similar. So if you can remember chai tea you can remember that cya is brown in Japanese.</p>
      </div>
      <div class="color-container">
        <h3>9. Green - 緑</h3> 
        <span>Me door is green.</span>
        <!-- <div>Picture</div> -->
        <p class="color-main-text">Imagine an Irishman showing off his proud green door and saying “me door is green”. This sounds similar to the word for green: me-door-ri. This one is pretty easy to pronounce.</p>
      </div>
      <div class="color-container">
        <h3>10. Silver - 銀 </h3> 
        <span>Is that real silver? It’s turning your neck gin.</span>
        <!-- <div>Picture</div> -->
        <p class="color-main-text">We just did green, next is silver. Silver is pronounced like the indian butter gee with an n at the end: gee-n. Hopefully all of your silver is real because if it’s not it’s gonna turn your neck gee-n. Hopefully this will help you remember that gee-n is Japanese for Silver. 
        </p>
      </div>
      <div class="color-container">
        <h3>11. Gold - 金</h3> 
        <span>You pass your gold onto your kin.</span>
        <!-- <div>Picture</div> -->
        <p class="color-main-text">Having gold has always been a sign of wealth, and what do you have with wealth? You pass it on to your kin. This is why gold is pronounced kin. Literally the word key with a n attached to the end. Or the spanish word for who Quien. This will get pretty close to the right pronunciation.</p>
      </div>
      <Quiz v-if=false :qn="qn" :style="{}" @fininshQuiz="submitQuiz"/>
      <div id="conclusion">As you begin your journey learning Japanese make sure to practice everyday using Lextend.io. One of keys to learning a new language is consistency, doing a little everyday is better than a lot at once. So with this in mind, keep going on your Japanese language adventure!</div>
    </div>
    <div class="column column-right">
    </div>
    </div>
</template>

<script>
import Quiz from '../components/Quiz.vue';

export default {
  name: "Colors",
  components: {
    Quiz
  },
  data() {
    return {
      qn: [{cfg: "select", options: [{character: '金', correct: false}, {character:'緑', correct: false},{character: '茶', correct: false},{character: '青', correct: true}], prompt: "Blue"},{cfg: "pronounce", character: "青", answer: "ao"}]
    };
  },
  methods: {
    submitQuiz(answers) {
      console.log(answers);
    }
  },
};
</script>

<style scoped>

#conclusion {
  margin-top: 50px;
  margin-bottom: 100px;
}

.color-main-text {
  margin-top: 30px;
}

.color-container {
  margin-top: 30px;
}

#title {
  margin-top: 50px;
}

#intro {
  margin-top: 30px;
}

.colors-view {
  text-align: left;
  font-family: Arial, sans-serif;
  display: flex;
  width: 100%;
}

/* Specific column widths */
.column-left {
  width: 15%; /* Left column occupies 20% */
  /* background-color:  #000080; */
}

.column-center {
  width: 70%; /* Center column occupies 60% */
  padding: 0 50px 0px 50px
}

.column-right {
  width: 15%; /* Right column occupies 20% */
  /* background-color:  #000080; */
}

</style>
